import { TransactionReportTable } from "components/Tables/TransactionReportTable/TransactionReportTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/transaction/")({
    component: TransactionsReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportTransaction],
        showInSideMenu: false,
        label: "pages.report.transaction.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.transaction.title"),
        };
    },
});

function TransactionsReportPage() {
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <TransactionReportTable />
        </TenantPage>
    );
}
